"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrapOrFromOption = void 0;
/**
 *  Unwraps a result _input_, returns the content of an `Some(T)`.
 *  If the value is an `None` then return _defaultValue_.
 */
function unwrapOrFromOption(input, defaultValue) {
    if (input.ok) {
        var val = input.val;
        return val;
    }
    return defaultValue;
}
exports.unwrapOrFromOption = unwrapOrFromOption;
